import service from './service.js';

export class ActivityService {

    recordActivity(getReport, copyLink, downloadReport, printReport, simpleReport, detailedReport, diagnosticReport, linkId) {
        //returns Promise object
        return service.getRestClient().post('/api/recordActivity', JSON.stringify({
            getReport: getReport,
            copyLink: copyLink,
            downloadReport: downloadReport,
            printReport: printReport,
            simpleReport: simpleReport,
            detailedReport: detailedReport,
            diagnosticReport: diagnosticReport,
            linkId: linkId
        }));
    }

}

export default (new ActivityService());